import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c877d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap" }
const _hoisted_2 = { class: "cell-wrap van-hairline--bottom" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "系统默认开票"),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "将按发票抬头“个人”开具电子普通发票")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "指定发票抬头"),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "电子发票将通过短信发送")
], -1))

import { useRouter } from 'vue-router'
import { withDefaults } from 'vue'
import PopupWrap from '@/components/popup/common-wrap.vue'
import IconArrowRightWrap from '@/components/icon/IconArrowRightWrap.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-type-select',
  props: {
    show: { type: Boolean, default: false },
    guid: { default: '' }
  },
  emits: ['update:show'],
  setup(__props: any, { emit: emits }) {

const props = __props as { show: boolean, guid: string };



const $router = useRouter()
function updateShwoHandle(value: boolean) {
  emits('update:show', value)
}

// 去往选择指定发票
function toSelectInvoice() {
  $router.push({
    name: 'invoice-user-invoice-list',
    query: {
      guid: props.guid,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    title: "发票申请",
    show: props.show,
    teleport: "body",
    "onUpdate:show": updateShwoHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(IconArrowRightWrap, { "fill-color": "rgba(0,0,0,0.44)" })
        ]),
        _createElementVNode("div", {
          class: "cell-wrap van-hairline--bottom",
          onClick: toSelectInvoice
        }, [
          _hoisted_4,
          _createVNode(IconArrowRightWrap, { "fill-color": "rgba(0,0,0,0.44)" })
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})